import type en from "../en";
import common from "./common.json";
import errors from "./errors.json";
import shell from "./shell.json";
import settings from "./settings.json";
import canvas from "./canvas.json";
import nole from "./nole.json";
import windows from "./windows.json";
import nodes from "./nodes.json";
import table from "./table.json";
import editor from "./editor.json";
import core from "./core.json";

// Annoté `typeof en` : une clé présente en anglais et absente ici ne compile
// pas. Les clés en trop sont repérées par src/i18n/locales.test.ts.
const fr: typeof en = {
  common,
  errors,
  shell,
  settings,
  canvas,
  nole,
  windows,
  nodes,
  table,
  editor,
  core,
};

export default fr;
